import { Typography as AntTypography } from 'antd'
import type { ComponentProps } from 'react'

type AntTextProps = ComponentProps<typeof AntTypography.Text>

export interface AppTextProps extends AntTextProps {}

export const AppText = (props: AppTextProps) => <AntTypography.Text {...props} />
